import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';

// Remove the baseURL setting to use relative URLs with the proxy
// axios.defaults.baseURL = 'http://localhost:3000';

// axios 설정
axios.interceptors.request.use(config => {
  const sessionKey = localStorage.getItem('userSessionKey');
  if (sessionKey) {
    config.headers['Authorization'] = `Bearer ${sessionKey}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// 응답 인터셉터 - 401 에러 처리
axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('userInfo');
    localStorage.removeItem('userSessionKey');
    router.push('/login');
  }
  return Promise.reject(error);
});

const app = createApp(App);
app.use(router);
app.provide('$router', router);
app.mount('#app');